/**
 * <sunday-open>: "Open now · until 7 pm" or "Opens at 10 am · until 7 pm" from the store's hours
 * text ("10 am to 7 pm"), in India time. Words come from the block; the dot turns green when open.
 */
const IST_OFFSET = 330; // minutes ahead of UTC

function parse(t) {
  const m = /(\d{1,2})(?::(\d{2}))?\s*(am|pm)/i.exec(t || '');
  if (!m) return null;
  let h = Number(m[1]) % 12;
  if (/pm/i.test(m[3])) h += 12;
  return { min: h * 60 + Number(m[2] || 0), label: `${m[1]}${m[2] ? ':' + m[2] : ''} ${m[3].toLowerCase()}` };
}

class SundayOpen extends HTMLElement {
  connectedCallback() {
    const parts = String(this.dataset.hours || '').split(/\s+(?:to|–|-)\s+/i);
    const a = parse(parts[0]);
    const b = parse(parts[1]);
    if (!a || !b) return;
    const now = new Date();
    const ist = (now.getUTCHours() * 60 + now.getUTCMinutes() + IST_OFFSET) % 1440;
    const open = ist >= a.min && ist < b.min;
    const text = (open ? this.dataset.open : this.dataset.opens) || '';
    this.querySelector('span').textContent = text.replace('[open]', a.label).replace('[close]', b.label);
    this.toggleAttribute('data-now', open);
  }
}
if (!customElements.get('sunday-open')) customElements.define('sunday-open', SundayOpen);
